/**
 * Procedure Categories and Procedures for DM in Pediatric Oncology students
 * Extracted with strict evidence from official NMC PDF (Page 4, 8, 10: "Psychomotor domain - perform independently")
 */
export const PEDIATRIC_ONCOLOGY_PROCEDURES = {
  "Diagnostic & Therapeutic Bone Marrow & Fluid Aspiration Procedures": [
    "Bone Marrow Aspiration & Trephine Biopsy",
    "Fine Needle Aspiration Cytology (FNAC) in Pediatric Oncology",
    "Peripheral Blood Smear & Bone Marrow Smear Preparation & Microscopy",
    "Lumbar Puncture with Intrathecal Chemotherapy Administration",
    "Diagnostic & Therapeutic Pleurocentesis (Pleural Fluid Aspiration) & Peritoneocentesis (Peritoneal Aspiration)",
    "Peripheral & Peripheral-Stem-Cell (PBSC) / Bone Marrow Harvest",
  ],
  "Chemotherapy Administration, Vascular Access & Supportive Care Procedures": [
    "Central Venous Access Insertion & Care (PICC Line, Hickman Catheter, Chemoport)",
    "Chemotherapy Drug Handling, Preparation & Administration (Intravenous, Intrathecal & Intracavitary)",
    "Management of Acute Chemotherapy Toxicity & Oncologic Emergencies (Tumour Lysis Syndrome)",
    "Blood Transfusion & Blood Component Therapy Administration",
    "Nasogastric (NG) Tube Insertion & Enteral / Parenteral Nutrition Setup",
  ],
};

export const PEDIATRIC_ONCOLOGY_CATEGORIES = Object.keys(PEDIATRIC_ONCOLOGY_PROCEDURES);

export const isDMInPediatricOncologyDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    d.includes("pediatric oncology") ||
    d.includes("paediatric oncology") ||
    d.includes("pediatric hemato-oncology")
  );
};
